import { Badge } from "@chakra-ui/react";
import { KYDSubscriptionStatus } from "@common/interfaces/KYDBilling";

// Define the billing status type
export type BillingStatus = KYDSubscriptionStatus;

// Interface for the status badge props
interface PaymentStatusBadgeProps {
  status?: BillingStatus;
  activeUntilDate?: string; // Optional date for "active_until" status
}

const PaymentStatusBadge = ({
  status,
  activeUntilDate,
}: PaymentStatusBadgeProps) => {
  const styleProps = {
    p: 1,
    px: 2,
    borderRadius: "md",
    fontSize: "sm",
  };

  const getBadgeProps = (status: BillingStatus, activeUntilDate?: string) => {
    switch (status) {
      case "OPEN":
        return {
          colorScheme: "green",
          variant: "subtle",
          children: "ACTIVE",
        };
      case "TRIALING":
        return {
          colorScheme: "blue",
          variant: "subtle",
          children: "TRIAL",
        };
      case "PAST_DUE":
        return {
          colorScheme: "red",
          variant: "solid",
          children: "OVERDUE",
        };
      case "CANCELED":
        return {
          colorScheme: "gray",
          variant: "outline",
          children: "CANCELLED",
        };
      default:
        return {
          colorScheme: "gray",
          variant: "subtle",
          children: "INACTIVE",
        };
    }
  };

  const badgeProps = getBadgeProps(status, activeUntilDate);

  return <Badge {...badgeProps} {...styleProps} />;
};

export default PaymentStatusBadge;
